export function SettingsPage() {
  return (
    <div className="card border-0 shadow-sm">
      <div className="card-header bg-white">
        <h3 className="h5 mb-0">Store Settings</h3>
      </div>
      <div className="card-body">
        <form className="row g-3">
          <div className="col-md-6">
            <label className="form-label" htmlFor="storeName">
              Store Name
            </label>
            <input
              id="storeName"
              className="form-control"
              defaultValue="Ninesistersjewels"
              type="text"
            />
          </div>
          <div className="col-md-6">
            <label className="form-label" htmlFor="supportEmail">
              Support Email
            </label>
            <input
              id="supportEmail"
              className="form-control"
              defaultValue="support@ninesistersjewels.com"
              type="email"
            />
          </div>
          <div className="col-12">
            <label className="form-label" htmlFor="shippingPolicy">
              Shipping Policy
            </label>
            <textarea
              id="shippingPolicy"
              className="form-control"
              rows={4}
              defaultValue="Orders are shipped within 48 hours across India."
            />
          </div>
          <div className="col-12">
            <button className="btn btn-primary" type="submit">
              Save Changes
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
